export default {
    setDriverDocuments (state, data) {
        state.driverDocuments = data
    },
    setTaxiDocuments (state, data) {
        state.taxiDocuments = data
    }
}
